// src/helpers/Config3D.ts
var Config3D = /* @__PURE__ */ ((Config3D2) => {
  Config3D2[Config3D2["hdr"] = 0] = "hdr";
  Config3D2[Config3D2["skybox"] = 1] = "skybox";
  Config3D2[Config3D2["simplifiedVersion"] = 2] = "simplifiedVersion";
  Config3D2[Config3D2["cardinalDirection"] = 3] = "cardinalDirection";
  Config3D2[Config3D2["pointerManager"] = 4] = "pointerManager";
  Config3D2[Config3D2["pinManager"] = 5] = "pinManager";
  Config3D2[Config3D2["minimap"] = 6] = "minimap";
  Config3D2[Config3D2["fitoutsManager"] = 7] = "fitoutsManager";
  Config3D2[Config3D2["fastTravelManager"] = 8] = "fastTravelManager";
  Config3D2[Config3D2["cameraScroll"] = 9] = "cameraScroll";
  Config3D2[Config3D2["floorEditor"] = 10] = "floorEditor";
  Config3D2[Config3D2["staticIcons"] = 11] = "staticIcons";
  Config3D2[Config3D2["separators"] = 12] = "separators";
  Config3D2[Config3D2["highlightManager"] = 13] = "highlightManager";
  Config3D2[Config3D2["materialShadows"] = 14] = "materialShadows";
  Config3D2[Config3D2["spaceVisibility"] = 15] = "spaceVisibility";
  Config3D2[Config3D2["analytics"] = 16] = "analytics";
  Config3D2[Config3D2["hidden"] = 17] = "hidden";
  Config3D2[Config3D2["multipleFitoutPositions"] = 18] = "multipleFitoutPositions";
  Config3D2[Config3D2["spaceOrFloor"] = 19] = "spaceOrFloor";
  Config3D2[Config3D2["resiHighlightManager"] = 20] = "resiHighlightManager";
  Config3D2[Config3D2["multipleLevelsManager"] = 21] = "multipleLevelsManager";
  Config3D2[Config3D2["resiLegacy"] = 22] = "resiLegacy";
  Config3D2[Config3D2["loggingEnabled"] = 23] = "loggingEnabled";
  Config3D2[Config3D2["lightmapFromAO"] = 24] = "lightmapFromAO";
  Config3D2[Config3D2["buildingOpacityOnHighlight"] = 25] = "buildingOpacityOnHighlight";
  Config3D2[Config3D2["buildingInteractionManager"] = 26] = "buildingInteractionManager";
  Config3D2[Config3D2["separateCullingPass"] = 27] = "separateCullingPass";
  Config3D2[Config3D2["configurableMaterialsManager"] = 28] = "configurableMaterialsManager";
  Config3D2[Config3D2["wayPointsManager"] = 29] = "wayPointsManager";
  return Config3D2;
})(Config3D || {});

export {
  Config3D
};
